import {
    doFetchTemplateList,
} from '@/services/configurationTemplate.service';
import { getField, updateField } from 'vuex-map-fields';
import { snakeToCamel } from "@/services/util.service";
export const configurationTemplateList = {
    namespaced: true,
    state: {
        inProgress: false,
        list: [],
    },
    getters: {
        getField
    },
    mutations: {
        updateField,

        inProgress(state, yesOrNo) {
            state.inProgress = yesOrNo
        },
        setList(state, list) {
            state.list = list
        },
    },
    actions: {
        fetchList: async ({ commit }, { sku }) => {
            try {
                commit('inProgress', true);
                const list = await doFetchTemplateList(sku);
                if (list) {
                    commit('setList', snakeToCamel(list));
                }
                commit('inProgress', false);
                return snakeToCamel(list)
            } catch (error) {
                commit('inProgress', false);
                throw error;
            }
        }
    },

}